var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "shape-button-arrow",
  "use": "shape-button-arrow-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" id=\"shape-button-arrow\"><path d=\"M14.485 9l-6.364 6.364L6 13.243 10.243 9 6 4.757l2.121-2.121L14.485 9z\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg-sprite/shape-button-arrow.svg
// module id = 41
// module chunks = 168707334958949